import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getSharedWaiver } from "store/digital-waiver"

export const useSharedWaiverData = (id) => {
  const dispatch = useDispatch()
  const { waiver, loading } = useSelector((store) => store.digitalWaiver)

  const status = waiver?.status || undefined
  const waiverSubmissionId = waiver?.waiver_submission_id || undefined

  useEffect(() => {
    if (id) {
      dispatch(getSharedWaiver(id))
    }
  }, [id, dispatch])

  return {
    waiver,
    loading,
    status,
    waiverSubmissionId
  }
}
